import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import ClinicalAreas from "@/pages/ClinicalAreas";
import Dispensing from "@/pages/Dispensing";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import WebsiteTerms from "@/pages/WebsiteTerms";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/clinical-areas" element={<ClinicalAreas />} />
        <Route path="/dispensing" element={<Dispensing />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/terms-of-use" element={<WebsiteTerms />} />
        <Route path="/website-terms" element={<WebsiteTerms />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
